
import './medias-area.scss'

import { faCheck, faImage, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import Component from "vue-class-component";

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Media } from '@skinsoft/ui/src/item-card/media';

import { Watch } from 'vue-property-decorator';
import { DELETE_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC } from '../../../../busTopics';


@Component({
    components: {
        sMedia: Media
    },
    props: ['mediasIds', 'id', 'canUpload', 'inProgress'],
    template: require("./medias-area.html")
})
export class MediaArea extends ReactiveVue {

    // Allows to differentiate multiple instances of this component in the defect tree
    public id: string;
    public mediasIds: string[];
    public canUpload: boolean;
    public inProgress: boolean;

    // Icons
    private addImageIcon = faImage;
    private deleteIcon = faTrash;
    private checkIcon = faCheck;
    private crossIcon = faTimes;

    private displayDeleteOverlayList: boolean[] = [];

    public mounted() {
        this.$on('id-changed-from-cache',
            (message) => {
                // Relaying media id modification from backend to parent component
                // in order to let it modify data if needed
                this.$parent.$emit('id-changed-from-cache', message)
            })
    }

    public onFileUploaded(event) {
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.addEventListener("load", () => {
            this.$parent.$emit(IMAGE_UPLOADED_TOPIC, { url: reader.result, file: event.target.files[0] })
        }, false);
    }

    public onImageClick(imageId, index) {
        this.$parent.$emit(IMAGE_CLICK_TOPIC, { id: imageId, imageListIndex: index })
    }

    public onTrashClick(index) {
        this.displayDeleteOverlayList[index] = !this.displayDeleteOverlayList[index]
        this.$forceUpdate()
    }


    public onDeleteImageClick(index) {
        this.$parent.$emit(DELETE_IMAGE_CLICK_TOPIC, { imageListIndex: index })
        this.mediasIds.splice(index, 1)
        this.displayDeleteOverlayList.splice(index, 1)
    }

    public cancelDelete(index) {
        this.displayDeleteOverlayList[index] = false
        this.$forceUpdate()
    }

    @Watch('mediasIds')
    public onMediasIdsChange() {
        this.mediasIds.map(
            (value, index) => {
                this.displayDeleteOverlayList.push(false);
            }
        )
    }

}